
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Documents from "../pages/documents/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/documents",
    element: <Documents />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
